import React from 'react'
import SignUp from '../components/Login/SignUp'

const SignUpPage = () => {
  return (
    <div>
     < SignUp />
    </div>
  )
}

export default SignUpPage
